import styled, { keyframes } from "styled-components";

import { MapLibreMapHost } from "@ryde/controls";
import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { orangeMui } from "@ryde/theme";

/**
 * Host for the investigation map — the shared `MapLibreMapHost` with this screen's sizing on top, so it
 * inherits the same MapLibre chrome every other map gets: the intrinsic-size marker fix, the popup styling,
 * the `.custom-tracking-tooltip` card the trail dots render into, the base-tile selector, and the translated
 * zoom/fullscreen tooltips. The legend goes in the host's `header` slot, which is inside the element
 * fullscreen targets, so it stays visible in both states.
 */
export const InvestigationMapHostStyled = styled(
  MapLibreMapHost,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-investigation-map",
})`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;

  .maplibregl-map {
    width: 100%;
    height: 100%;
  }

  /* The highlight ring's marker sits over the station pin; clicks go through it to the pin. */
  .investigation-station-highlight {
    pointer-events: none;
  }
`;

const stationHighlightPulse = keyframes`
  50% {
    transform: scale(1.15);
  }
`;

/** Ring around a stop the selected Timeline row is about. */
export const StationHighlightRingStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-investigation-station-highlight",
})`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid ${orangeMui._600};
  box-shadow: 0 0 0 3px ${orangeMui._100};
  pointer-events: none;

  @media (prefers-reduced-motion: no-preference) {
    animation: ${stationHighlightPulse} 1.6s ease-in-out infinite;
  }
`;
